import { jsxs as e, jsx as l } from "react/jsx-runtime";
const r = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l("rect", { width: "18", height: "18", rx: "6", fill: "var(--plac-lines-default)" }),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.62514 13.875L14.4646 7.03553C14.8075 6.69264 15.0001 6.22757 15.0001 5.74264C15.0001 4.22792 13.7722 3 12.2575 3C11.7726 3 11.3075 3.19264 10.9646 3.53553L4.12514 10.375L3.19428 14.2018C3.10573 14.5659 3.43424 14.8944 3.79829 14.8059L7.62514 13.875ZM12.2575 4C12.0378 4 11.8271 4.08728 11.6717 4.24264L11.3107 4.60362L13.3965 6.68941L13.7575 6.32843C13.9129 6.17307 14.0001 5.96235 14.0001 5.74264C14.0001 4.78021 13.2199 4 12.2575 4ZM5.56073 10.3536L10.6036 5.31073L12.6894 7.39652L7.64651 12.4394L5.56073 10.3536ZM4.9613 11.1684L4.3601 13.64L6.83173 13.0388L4.9613 11.1684Z",
          fill: "var(--plac-primary-gray)"
        }
      )
    ]
  }
);
export {
  r as ChipEditIcon
};
//# sourceMappingURL=index.es5487.js.map
